import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CollageService } from 'src/app/core/services/collage.service';
import { PresetService } from 'src/app/core/services/preset.service';
import { IPreset } from 'src/app/core/models/preset.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-collage-setup',
  templateUrl: './collage-setup.component.html',
  styleUrls: ['./collage-setup.component.css']
})
export class CollageSetupComponent implements OnInit {

  @Input() userPresets: any;
  @Input() collages: any;
  @Input() currentUser: any;
  @Input() userId: string;
  @Input() selectedSetting: any;
  @Input() selectedCollageSetup: any;

  @Output() initializePresets = new EventEmitter<Object>();

  selectedPresetForCollage;
  collageSetupModal;
  isAssignCollage = false;
  selectedPosition;
  targetSelection;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal'
  };

  constructor(
    private modalService: NgbModal,
    private collageService: CollageService,
    private presetService: PresetService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCollageSetup(content, preset) {
    if (this.currentUser?.readOnlyPermissions) {
      return false;
    }
    
    this.selectedPresetForCollage = preset;

    this.selectedPresetForCollage.targets.sort((a, b) => {
      return a.position - b.position;
    });

    this.selectedCollageSetup = null; // preset doesnt have collage
    if (this.selectedPresetForCollage.collage) {
      this.selectedCollageSetup = this.selectedPresetForCollage.collage; // preset have collage
      this.initializeCollageSetup(this.selectedCollageSetup);
    }

    this.collageSetupModal = this.modalService.open(content, this.dialogOptions);
    this.collageSetupModal.result.then((result) => {
      
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }

  initializeCollageSetup(collage) {

    const positions = collage.positionKeys.length;
    collage.dynamicPositions = new Array(positions);
    collage.positionKeys.forEach((key, index) => {
      collage.dynamicPositions[index] = { target: null, key };
    });

    console.log(collage.dynamicPositions);

    const textKeys = Object.keys(collage.textKeys).length;
    collage.dynamicTexts = new Array(textKeys);
    Object.entries(collage.textKeys).forEach(([key, value], index) => {

      collage.dynamicTexts[index] = { key, required: value, value: null };
    });

    if (collage.collagePresets) {

      collage.targetSelection = [];

      Object.values(collage.collagePresets.positions).forEach((value, index) => {
        console.log(value);
        this.selectedPresetForCollage.targets.forEach(target => {
          if (target.position === value) {
            // collage.targetSelection.push(target)
            collage.dynamicPositions[index].target = target;
          }
        });

      });

      Object.entries(collage.collagePresets.texts).forEach(([key, value]) => {
        console.log(collage.dynamicTexts.find(e => e.key === key));
        collage.dynamicTexts.find(e => {
          if (e.key === key) {
            e.value = value;
          }
        });
      });
      console.log(collage.dynamicTexts);
    }

    collage.dynamicTexts.sort(function (x, y) { return y.required - x.required });
  }


  selectCollage(collage) {
    this.selectedCollageSetup = collage;
    console.log(this.selectedCollageSetup)
    console.log(this.selectedPresetForCollage)

    if (this.selectedCollageSetup) {

      if (this.selectedPresetForCollage.collage) {

        // ako je to vec izabrani (trenutni) kolaz
        // dodeljujeno selectedPresetForCollage.collage zato sto
        // on sadrzi vec izabrane targete
        if (this.selectedCollageSetup.id === this.selectedPresetForCollage.collage.id) {
          this.isAssignCollage = true;
          this.selectedCollageSetup = this.selectedPresetForCollage.collage;
          this.initializeCollageSetup(this.selectedCollageSetup);
        } else {
          this.initializeCollageSetup(this.selectedCollageSetup);
        }

      } else {
        this.initializeCollageSetup(this.selectedCollageSetup);
      }

    }
  }

  openSelectTarget(content, position) {
    this.selectedPosition = position;

    this.targetSelection = this.modalService.open(content, this.dialogOptions);
    this.targetSelection.result.then((result) => {
      
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }

  selectTarget(target) {
    this.selectedPosition.target = target;

    this.targetSelection.close();
  }
  loadUserPresets(settingsProfileId?: string): Observable<IPreset[]> {
    return this.presetService.getPresetsOfUser(this.userId, settingsProfileId);
  }

  assignCollage() {
    // AKO JE SELEKTOVAN NO COLLAGE
    // I POSTOJI VEC NEKI PRETHODNI
    if (this.selectedCollageSetup == null && this.selectedPresetForCollage.collage) {
      this.collageService.unassignCollage(this.userId, this.selectedPresetForCollage.collage.id, this.selectedPresetForCollage.id, this.selectedSetting?.id).subscribe(res => {
        
        this.collageSetupModal.close();
        // this.initializePresets();
        this.loadUserPresets(this.selectedSetting?.id).subscribe(res => {
          this.initializePresets.emit(res);
        });

        console.log('deleted');
      });
    } else if (this.selectedPresetForCollage.collage && this.selectedPresetForCollage.collage.id === this.selectedCollageSetup.id) { // EDIT
      const texts = this.selectedCollageSetup.dynamicTexts.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.value }), {});
      const positions = this.selectedCollageSetup.dynamicPositions.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.target.position }), {});
      const body = {
        positions,
        texts
      };
      console.log(body);
      this.collageService.updateAssignedCollage(this.userId, this.selectedCollageSetup.id, this.selectedPresetForCollage.id, body, this.selectedSetting?.id).subscribe(res => {
        
        this.collageSetupModal.close();
        // this.initializePresets();
        this.loadUserPresets(this.selectedSetting?.id).subscribe(res => {
          this.initializePresets.emit(res);
        });
        console.log('updated');
        this.toastr.success('Collage updated');
      });

    } else {
      let error = Object.values(this.selectedCollageSetup.dynamicPositions).some((value: any, index) => {
        return value.target === null;
      });

      if (error) {
        return this.toastr.info('You need to select all positions.');
      }

      // SELEKTOVAN NEKI KOLAZ
      const texts = this.selectedCollageSetup.dynamicTexts.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.value }), {});
      const positions = this.selectedCollageSetup.dynamicPositions.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.target.position }), {});
      const body = {
        presetId: this.selectedPresetForCollage.id,
        positions,
        texts
      };
      console.log(body);
      this.collageService.assignCollage(this.userId, this.selectedCollageSetup.id, body, this.selectedSetting?.id).subscribe(res => {
        
        this.collageSetupModal.close();
        // this.initializePresets();
        this.loadUserPresets(this.selectedSetting?.id).subscribe(res => {
          this.initializePresets.emit(res);
        });
        console.log('assigned');
        this.toastr.success('Collage assigned');
      });
    }

  }

  isEmpty(text) {
    if (text.value === '') {
      text.value = null;
    }
  }

}
